/* eslint-disable functional/immutable-data */

import type { Cache } from '@urql/exchange-graphcache';

import type { CartDataFragment, SubmitOrderMutation } from '@order/graphql';
import { CartDocument } from '@order/graphql';

// ────────────────────────────────────────────────────────────────────────────────

export function updateCartCache(
  cache: Cache,
  responseWithCart: MutationResponseWithCart,
) {
  if (!responseWithCart.cart) return;

  cache.updateQuery({ query: CartDocument }, (data) => {
    const shouldUpdateCache = data && responseWithCart.cart;

    if (shouldUpdateCache) data.cart = responseWithCart.cart;

    return data;
  });
}

export function invalidateCartCacheEntry(
  cache: Cache,
  result: SubmitOrderMutation['submitOrderUsingBillingAccount'],
) {
  const isSubmitted =
    result?.__typename === 'SubmitOrderUsingBillingAccountSuccess';

  if (isSubmitted) {
    cache.updateQuery({ query: CartDocument }, (data) => {
      if (data) data.cart = null;

      return data;
    });
  }
}

// ─── TYPES ──────────────────────────────────────────────────────────────────────

export type MutationResponseWithCart = {
  readonly cart?: CartDataFragment;
  readonly __typename?: string;
};
